import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import React from 'react'
import createCommonEntitySettings from '../createCommonEntitySettings'
import WebinarRegistrationDateSettings from './settings/WebinarRegistrationDateSettings'

function createSettingsForWebinarRegistration(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.WebinarRegistrationDate:
      return (
        <WebinarRegistrationDateSettings
          entity={entity as WebinarRegistrationDateInterface}
          defaultEntity={defaultEntity as WebinarRegistrationDateInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForWebinarRegistration
